import pages from './nav-pages'
import admin from './nav-admin'
import users from './nav-users'

export default [...pages, ...admin, ...users]
